'use client'

import Lightbox, { type LightboxExternalProps } from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'

const containerStyle = {
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  backdropFilter: 'blur(20px)',
}

const slideStyle = { padding: 'clamp(1.5rem, 5vw, 6rem)' }

export default function BlurredLightbox({ styles, carousel, ...rest }: LightboxExternalProps) {
  return (
    <Lightbox
      carousel={{ imageFit: 'contain', ...carousel }}
      styles={{
        ...styles,
        container: { ...containerStyle, ...styles?.container },
        slide: { ...slideStyle, ...styles?.slide },
      }}
      {...rest}
    />
  )
}
